import React, { useCallback, useEffect } from 'react'
import cn from 'classnames'
import styles from './VacancyTypeSwitcher.module.scss'
import Button from '../../../UI/Button/Button'

import { setVacancyType, clearVacancyType } from '../../../redux/vacancyManager/vacancyManager.action'
import { useDispatch, useSelector } from 'react-redux'
import { vacancyTypes } from '../VacancyManagerForm/constants'

const VacancyTypeSwitcher = () => {
    const dispatch = useDispatch()
    const { vacancyType, currentInEdit } = useSelector(({ vacancies }) => vacancies)

    const handleVacancyTypeChange = useCallback((type) => {
        dispatch(setVacancyType(type))

        // eslint-disable-next-line
    }, [dispatch])

    useEffect(() => {
        return () => {
            if(vacancyType !== 'sea') dispatch(clearVacancyType())
        }
    }, [dispatch, vacancyType])

    return (
        <div
            className={cn(styles.switcherTypeVacancyWrapper, {
                [styles.switcherTypeVacancyWrapper__disabled]: Boolean(currentInEdit),
            })}
        >
            <div className={styles.switcherTypeVacancy}>
                <Button
                    theme="text"
                    className={cn(styles.typeVacancyButton, {
                        [styles.typeVacancyButtonActive]: vacancyType === vacancyTypes.land,
                    })}
                    type="button"
                    onClick={() => handleVacancyTypeChange(vacancyTypes.land)}
                >
                    Land
                </Button>

                <Button
                    theme={'text'}
                    className={cn(styles.typeVacancyButton, {
                        [styles.typeVacancyButtonActive]: vacancyType === vacancyTypes.sea,
                    })}
                    type="button"
                    onClick={() => handleVacancyTypeChange(vacancyTypes.sea)}
                >
                    At sea
                </Button>
            </div>
        </div>
    )
}

export default VacancyTypeSwitcher